import React from 'react'

const ColorsIcon = (props) => {
  return (
    <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path d='M9.93838 12.6627C15 14 17.3132 10 17.3132 7.34875C17.3132 3.49999 10.9919 -0.62204 5.19741 2.56632C-0.597107 5.75468 -0.597108 16.3824 9.93838 17.4452' stroke='#33354D' strokeLinecap='round' />
      <circle cx='13.5' cy='7.5' r='1.5' fill='#33354D' />
      <circle cx='9.5' cy='5.5' r='1.5' fill='#33354D' />
      <circle cx='5.5' cy='7.5' r='1.5' fill='#33354D' />
      <circle cx='6.5' cy='11.5' r='1.5' fill='#33354D' />
    </svg>
  )
}

export default ColorsIcon
